import { useLocation } from '@tanstack/react-router'
import { useScreenCapture } from 'hooks/use-analytics'
import { PropsWithChildren, useEffect } from 'react'

export function RouterListener(props: PropsWithChildren) {
  const { screenOpened } = useScreenCapture()
  const location = useLocation()

  useEffect(() => {
    screenOpened(location.search['stage'])
  }, [screenOpened, location.search])

  return props.children
}
